var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02051 8.96655C9.97788 9.68132 12.1112 9.68132 14.0686 8.96655",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3452 1.21436H5.74463C3.40239 1.21436 1.5 3.12774 1.5 5.45899V20.953C1.5 22.9323 2.91854 23.7681 4.65598 22.8114L10.0222 19.8313C10.5941 19.5125 11.5178 19.5125 12.0786 19.8313L17.4449 22.8114C19.1823 23.7791 20.6008 22.9433 20.6008 20.953V5.45899C20.5898 3.12774 18.6875 1.21436 16.3452 1.21436Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3452 1.21436H5.74463C3.40239 1.21436 1.5 3.12774 1.5 5.45899V20.953C1.5 22.9323 2.91854 23.7681 4.65598 22.8114L10.0222 19.8313C10.5941 19.5125 11.5178 19.5125 12.0786 19.8313L17.4449 22.8114C19.1823 23.7791 20.6008 22.9433 20.6008 20.953V5.45899C20.5898 3.12774 18.6875 1.21436 16.3452 1.21436Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackTab);
export default __webpack_public_path__ + "static/media/FeedbackTab.91e18cd955688bb73dece8a875f4283a.svg";
export { ForwardRef as ReactComponent };